module.exports = __webpack_public_path__ + "img/service_3.1fae08b4.png";